import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd1f4304"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-month-grid" }
const _hoisted_2 = { class: "dashboard-month-card__icon text-primary" }
const _hoisted_3 = { class: "dashboard-month-card__body" }
const _hoisted_4 = { class: "dashboard-month-card__label" }
const _hoisted_5 = { class: "dashboard-month-card__value" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "dashboard-month-card__breakdown"
}
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "dashboard-month-card__legend" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardItems, (card) => {
      return (_openBlock(), _createElementBlock("article", {
        key: card.label,
        class: _normalizeClass([
        'dashboard-month-card',
        card.desktopClass,
      ])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass(card.icon)
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(card.label), 1),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(card.value), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.meta, (meta) => {
            return (_openBlock(), _createElementBlock("span", {
              key: meta,
              class: "dashboard-month-card__meta"
            }, _toDisplayString(meta), 1))
          }), 128)),
          (card.failed)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "dashboard-month-card__retry",
                disabled: _ctx.insightsLoading,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retryInsights && _ctx.retryInsights(...args)))
              }, _toDisplayString(_ctx.insightsLoading ? 'Carregando...' : 'Tentar novamente'), 9, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        (card.segments && card.segments.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "dashboard-month-card__distribution",
                role: "img",
                "aria-label": card.distributionLabel
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.segments, (segment) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: segment.label,
                    class: _normalizeClass(`dashboard-month-card__segment--${segment.color}`),
                    style: _normalizeStyle({ width: `${segment.width}%` })
                  }, null, 6))
                }), 128))
              ], 8, _hoisted_8),
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.segments, (segment) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: segment.label
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["dashboard-month-card__dot", `dashboard-month-card__segment--${segment.color}`]),
                      "aria-hidden": "true"
                    }, null, 2),
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(segment.label) + ": ", 1),
                      _createElementVNode("strong", null, _toDisplayString(segment.count), 1),
                      _createTextVNode(" (" + _toDisplayString(_ctx.formatPercent(segment.percentage)) + ")", 1)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}